import type EnrollmentFormData from '@UI/Pages/Authentication/SecondFactorEnrollment/FormData/EnrollmentFormData';
import { css } from '@emotion/react';
import type * as React from 'react';
import { Button, InputText } from '@verclam/ui-kit';
import { fieldMarginStyles } from '@Guidelines/Theme/commonStyles';

const formStyle = css`
	display: flex;
	flex-direction: column;
	gap: 1.25rem;
`;

type Props = {
	readonly formData: EnrollmentFormData;
	readonly onCodeChange: (value: string) => void;
	readonly onSubmit: (event: React.SyntheticEvent<HTMLFormElement>) => void;
	readonly isSubmitting: boolean;
};

/** Enrollment verification step: the first code confirms the pairing before any recovery code exists. */
const VerificationStep: React.FC<Props> = ({ formData, onCodeChange, onSubmit, isSubmitting }) => {
	return (
		<form css={formStyle} onSubmit={onSubmit}>
			<p css={fieldMarginStyles}>Saisissez le code affiché par votre application d’authentification.</p>
			<InputText
				name="code"
				label="Code de vérification"
				keyfilter="pint"
				maxLength={6}
				autoFocus
				required
				value={formData.code}
				onChange={onCodeChange}
				errorMessage={formData.getValidationMessage('code')}
				isFormFieldValid={formData.isValid('code')}
			/>
			<Button type="submit" label="Activer" loading={isSubmitting} css={fieldMarginStyles} />
		</form>
	);
};

export default VerificationStep;
